"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementAnimationTimeByWidth = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var AnimatedTimerQueueWrapper_1 = __importDefault(require("./AnimatedTimerQueueWrapper"));
var defaultMovedPxPerSec = 200;
exports.getElementAnimationTimeByWidth = function (width, speedPxPerSec) { return (width > 0 ? (width / speedPxPerSec) : undefined); };
var useMarqueeWrapper = function (_a) {
    var children = _a.children, movedPxPerSec = _a.movedPxPerSec, autoCalIntervalSeconds = _a.autoCalIntervalSeconds;
    var wrapperRef = react_1.useRef();
    var childrenRef = children.map(function (c) { return react_1.createRef(); });
    var _b = react_1.useState(0), wrapperWidth = _b[0], setWrapperWidth = _b[1];
    var _c = react_1.useState([]), childrenWidth = _c[0], setChildrenWidth = _c[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    react_1.useEffect(function () {
        if (wrapperRef.current) {
            // console.log(wrapperRef.current.clientWidth);
            setWrapperWidth(wrapperRef.current.clientWidth);
        }
        var updateRefTimer = setTimeout(function () {
            childrenRef.forEach(function (c, i) {
                if (c.current) {
                    setChildrenWidth(function (w) {
                        var newWidth = __spreadArrays(w);
                        newWidth[i] = c.current ? c.current.clientWidth : 0;
                        return newWidth;
                    });
                }
            });
        }, 1 * 1000);
        // clearTimeout(updateRefTimer);
        return function () { return clearTimeout(updateRefTimer); };
    });
    var marqueeLeftDuration = exports.getElementAnimationTimeByWidth(wrapperWidth, movedPxPerSec);
    var intervalSecs = childrenWidth.map(function (c) { return exports.getElementAnimationTimeByWidth(c, movedPxPerSec) || 0; });
    // console.log(children, wrapperWidth, childrenWidth, marqueeLeftDuration, intervalSecs);
    return ({
        intervalSecs: autoCalIntervalSeconds ? intervalSecs : undefined,
        marqueeLeftDuration: marqueeLeftDuration,
        childrenRef: childrenRef,
        wrapperRef: wrapperRef,
    });
};
var MarqueeWrapper = function (props) {
    var autoCalIntervalSeconds = props.autoCalIntervalSeconds, children = props.children, _a = props.movedPxPerSec, movedPxPerSec = _a === void 0 ? defaultMovedPxPerSec : _a;
    // if children is only one, should duplicate itself
    var marqueeChildren = children.length === 1 ? __spreadArrays(children, children) : children;
    var _b = useMarqueeWrapper({
        movedPxPerSec: movedPxPerSec,
        children: marqueeChildren,
        autoCalIntervalSeconds: autoCalIntervalSeconds,
    }), wrapperRef = _b.wrapperRef, intervalSecs = _b.intervalSecs, marqueeLeftDuration = _b.marqueeLeftDuration, childrenRef = _b.childrenRef;
    var _children = react_1.default.Children.map(marqueeChildren, function (child, i) { return (react_1.default.cloneElement((react_1.default.createElement("div", { key: i, ref: childrenRef[i] }, child)))); });
    return (react_1.default.createElement(core_1.RootRef, { rootRef: wrapperRef },
        react_1.default.createElement(core_1.Box, null,
            react_1.default.createElement(AnimatedTimerQueueWrapper_1.default, __assign({}, props, { intervalSeconds: intervalSecs ? intervalSecs : props.intervalSeconds, marqueeLeftDuration: marqueeLeftDuration, animateEffect: 'marquee' }), _children || []))));
};
exports.default = MarqueeWrapper;
